import { render, staticRenderFns } from "./LogoPath.vue?vue&type=template&id=56663f99&scoped=true&"
var script = {}
import style0 from "./LogoPath.vue?vue&type=style&index=0&id=56663f99&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56663f99",
  null
  
)

export default component.exports